// extracted by mini-css-extract-plugin
export default {"panel":"Login_panel__4NrOB","logo":"Login_logo__eROWU","backgroundImage":"Login_backgroundImage__-CrNn","form":"Login_form__kWRbp"};